import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ArquivoBlobDTO } from "../../model/arquivoBlob.dto";
import {GenericService} from "../../commons/generic.service";
import { AnexoBenseValores } from "../../model/anexoBenseValores";
import { Page } from "../../model/Paginacao/Page";

@Injectable()
export class ImpostoRendaService extends GenericService {
  protected url: string = environment.url;
  private relativePath = 'api/v1/bens-valores/anexo/';
  private relativePathAdmin = 'api/v1/bens-valores/admin/anexo/';
  private relativePathUpload = 'api/v1/inclusao-declaracao-ir/';

  constructor(http: HttpClient) {
    super(http);
  }

  downloadComprovanteDeclaracao(id: number): Observable<ArquivoBlobDTO> {
    const options = {
      responseType: 'blob' as 'json'
    };
    return this.http.get<ArquivoBlobDTO>(`${this.url}${this.relativePath}${id}/comprovante-declaracao-irpf`, options);

  }

  uploadComprovanteIR(ano: number, arquivo: File): Observable<any> {
    const formData = new FormData();
    formData.append('ano', ano.toString());
    formData.append('comprovanteIr', arquivo);

    return this.postMethodFile(this.relativePathUpload + 'upload-comprovante', formData);
  }

  getListaAnexos(page: number, size: number): Observable<Page<AnexoBenseValores>> {
    return this.getMethod(`${this.relativePath}lista/pagina/${page}/tamanho/${size}`);
  }

  downloadReciboArquivoAutorizacao(id: number) {
    const options = {
      responseType: 'blob' as 'json'
    };
    return this.http.get<ArquivoBlobDTO>( `${this.url}${this.relativePath}${id}/comprovante-autorizacao-irpf`, options);
  }

  baixarDeclaracao(ano: number) {
    const options = {
      responseType: 'blob' as 'json'
    };
    return this.http.get<ArquivoBlobDTO>( `${this.url}${this.relativePathUpload}visualizar-arquivo-enviado/${ano}`, options);
  }


  // Metodos para admin e master

  getListaAnexosOutrosUsuarios(page: number, size: number, matricula: string): Observable<Page<AnexoBenseValores>> {
    return this.getMethod(`${this.relativePathAdmin}lista/pagina/${page}/tamanho/${size}/matricula/${matricula}`);
  }

  downloadComprovanteDeclaracaoOutroUsuario(id: number, matricula: string): Observable<ArquivoBlobDTO> {
    const options = {
      responseType: 'blob' as 'json'
    };
    return this.http.get<ArquivoBlobDTO>(`${this.url}${this.relativePathAdmin}matricula/${matricula}/comprovante/${id}/comprovante-declaracao-irpf`, options);
  }

  downloadReciboArquivoAutorizacaoOutroUsuario(id: number, matricula: string) {
    const options = {
      responseType: 'blob' as 'json'
    };
    return this.http.get<ArquivoBlobDTO>( `${this.url}${this.relativePathAdmin}matricula/${matricula}/comprovante/${id}/comprovante-autorizacao-irpf`, options);
  }

  baixarDeclaracaoOutroUsuario(ano: number, matricula: string) {
    const options = {
      responseType: 'blob' as 'json'
    };
    return this.http.get<ArquivoBlobDTO>( `${this.url}${this.relativePathAdmin}matricula/${matricula}/visualizar-arquivo-enviado/${ano}`, options);
  }

}
